/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo, useState } from 'react'
import block from 'bem-cn'
import { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperClass, SwiperProps, SwiperSlide } from 'swiper/react'
import { PaginationOptions } from 'swiper/types'

import './Slider.scss'

import 'swiper/css'
import 'swiper/css/pagination'

interface ISlider {
  items: React.ReactNode[]
  isWithPagination?: boolean
  slidesToShow?: number
  initialSlide?: number
  centeredSlides?: boolean
  spaceBetween?: number
  autoplay?: boolean
  infinite?: boolean
}

const b = block('slider')

const Slider: React.FC<ISlider> = ({
  items,
  isWithPagination = true,
  slidesToShow = 1,
  initialSlide = 0,
  centeredSlides,
  infinite = true,
  spaceBetween,
  autoplay,
}) => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass>()

  const isNeedNavigation = useMemo(
    () => isWithPagination && items.length > slidesToShow,
    [isWithPagination, items, slidesToShow],
  )

  const properties: SwiperProps = useMemo(
    () => ({
      loop: infinite,
      speed: 1000,
      slidesPerView: slidesToShow,
      initialSlide,
      centeredSlides,
      spaceBetween,
      autoplay:
        autoplay !== undefined && autoplay
          ? {
              delay: 10000,
              disableOnInteraction: false,
              waitForTransition: true,
            }
          : false,
      pagination: isNeedNavigation,
    }),
    [infinite, autoplay, centeredSlides, slidesToShow, initialSlide, isNeedNavigation, spaceBetween],
  )
  const pagination: PaginationOptions | undefined = useMemo(
    () =>
      isNeedNavigation
        ? {
            clickable: true,
          }
        : undefined,
    [isNeedNavigation],
  )

  const slidesList = useMemo(() => items.map((item, index) => <SwiperSlide key={index}>{item}</SwiperSlide>), [items])

  useEffect(() => {
    if (swiperRef) {
      swiperRef?.autoplay.start()
    }
  }, [swiperRef])

  return (
    <div className={b()}>
      {items.length > 0 && (
        <Swiper
          onSwiper={setSwiperRef}
          {...properties}
          className="mySwiper"
          modules={[Autoplay, Pagination, Navigation]}
          pagination={pagination}
          style={{ direction: 'ltr' }}>
          {slidesList}
        </Swiper>
      )}
    </div>
  )
}

export default Slider
